import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class BookingItemForCostDocument {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  grandTotal!: number;
  @IsString()
  @Expose()
  currency!: string;
  @IsString()
  @Expose()
  passengerName!: string;
  @IsOptional()
  @IsString()
  @Expose()
  ticketNumber!: string | null;
  @IsBoolean()
  @Expose()
  isPairWithCostDocument!: boolean;
  @IsOptional()
  @IsString()
  @Expose()
  documentsNumber!: null | string;
}

export class BookingForCostDocument {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  recordLocator!: string;
  @IsString()
  @Expose()
  contractor!: string;
  @IsBoolean()
  @Expose()
  bookingHasAttachment!: boolean;
  @IsBoolean()
  @Expose()
  isPairWithCostDocument!: boolean;
  @Type(() => BookingItemForCostDocument)
  @Expose()
  bookingItems!: Array<BookingItemForCostDocument>;
}

export class BookingItemForCostDocumentResponse extends GenericTableResponse<BookingForCostDocument> {
  @Type(() => BookingForCostDocument)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<BookingForCostDocument>;
}
